import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-cutting-type',
	templateUrl: './cutting-type.component.html',
	styleUrls: ['./cutting-type.component.scss']
})
export class CuttingTypeComponent implements OnInit {


	@Input() onClose: any;

	item:any = null;
	cuttingType:any = null;
	env:any = environment;
	seletectedCuttingTpe:any = null;

	constructor() { }

	ngOnInit(): void {
		this.item.product.options.forEach(option => {
			if(option.title == 'cutting type'){
				this.cuttingType = option;
			}
		});
	}

	setCuttingType(val){
		this.seletectedCuttingTpe = val;
	}

	reAddToCart(){
		this.onClose([
			{
				option_id: this.cuttingType.option_id,
				option_value: this.seletectedCuttingTpe.option_type_id
			}
		]);
	}

	get totalPrice (){
		let cuttingTypePrice:any = 0;
		if(this.seletectedCuttingTpe){
			cuttingTypePrice = this.seletectedCuttingTpe.price;
		}

		let perPiece = parseFloat(this.item.parent_item.base_price) + parseFloat(cuttingTypePrice);

		let total:any = this.item.qty_ordered * perPiece;

		return total + '';
	}
}
